const Star = ({ fill }) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <linearGradient id={`grad${fill}`} x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset={`${fill}%`} stopColor="#ffc107" />
        <stop offset={`${fill}%`} stopColor="lightgray" />
      </linearGradient>
    </defs>
    <path
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
      fill={`url(#grad${fill})`}
    />
  </svg>
);

const AverageStarRating = ({ level, max=5, }) => {
  const stars = [];
  for (let i = 1; i <= max; i++) {
    let fill = 0;
    if (i <= Math.floor(level)) {
      fill = 100;
    } else if (i === Math.ceil(level) && level % 1 !== 0) {
      fill = (level % 1) * 100;
    }
    stars.push(<Star key={i} fill={fill} />);
  }
  return <div style={{ display: 'flex' }}>{stars}</div>;
};

export default AverageStarRating;